// extracted by mini-css-extract-plugin
export var dateLabel = "_4b-0";
export var dateLabelError = "_4b-1";
export var fullWidth = "_4b-2";
export var smaller = "_4b-3";